import { render } from "./RadioOnOff.vue?vue&type=template&id=5c0936d7"
import script from "./RadioOnOff.vue?vue&type=script&lang=js"
export * from "./RadioOnOff.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__